<ng-container>
    <ng-container *ngIf="useMenuIconAvatar; else defaultAvatar">
        <ng-container *ngTemplateOutlet="avatarIcon"></ng-container>
    </ng-container>
</ng-container>

<ng-template #defaultAvatar>
    <svg
        class="text-black dark:text-contrast-yellow"
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22 0C9.84677 0 0 9.84668 0 21.9998C0 34.1529 9.84677 43.9996 22 43.9996C34.1532 43.9996 44 34.1529 44 21.9998C44 9.84668 34.1532 0 22 0ZM22 8.51605C26.3113 8.51605 29.8065 12.0112 29.8065 16.3224C29.8065 20.6337 26.3113 24.1288 22 24.1288C17.6887 24.1288 14.1935 20.6337 14.1935 16.3224C14.1935 12.0112 17.6887 8.51605 22 8.51605ZM22 39.0319C16.7927 39.0319 12.1266 36.6722 9.00403 32.9819C10.6718 29.8416 13.9363 27.6771 17.7419 27.6771C17.9548 27.6771 18.1677 27.7126 18.3718 27.7747C19.525 28.1473 20.7315 28.3868 22 28.3868C23.2685 28.3868 24.4839 28.1473 25.6282 27.7747C25.8323 27.7126 26.0452 27.6771 26.2581 27.6771C30.0637 27.6771 33.3282 29.8416 34.996 32.9819C31.8734 36.6722 27.2073 39.0319 22 39.0319Z"
            fill="currentColor" />
    </svg>
</ng-template>

<ng-template #avatarIcon>
    <ion-icon class="h-16 w-16" aria-hidden="true" src="{{ assetsPath$ | async }}/img/menu/user.svg"></ion-icon>
</ng-template>
